import { EnhancedWithAuthHttpService } from './http-auth.service'
import { axiosInstance } from './http-common.service'
import { HttpService } from './http.service'
import {
  IImpactByIdRespDto,
  IImpactCreateDto,
  IImpactScanToEarnInfoRespDto,
  IImpactsRespDto,
  IImpactUpdateDto,
} from 'src/types/impacts.type'
import axios, { Canceler } from 'axios'
import { ICancelRemovalDto, IMessageResponseDto } from 'src/types'

class ImpactDataService extends EnhancedWithAuthHttpService {
  CancelToken
  cancel?: Canceler

  constructor() {
    super(new HttpService(axiosInstance))
    this.CancelToken = axios.CancelToken
  }
  async createImpact(dto: IImpactCreateDto) {
    return await this.post<string, IImpactCreateDto>(`impacts`, dto)
  }

  async getImpactById(id: string, locale: string) {
    return await this.get<IImpactByIdRespDto>(`impacts/${id}/${locale}`)
  }

  async getImpactScanToEarnInfoById(id?: string) {
    return await this.get<IImpactScanToEarnInfoRespDto[]>(`impacts/ics/${id}`)
  }

  async editImpact(dto: IImpactUpdateDto, id: string) {
    return await this.put<string, IImpactUpdateDto>(`impacts/${id}`, dto)
  }

  async removeImpacts(ids: string[]) {
    return await this.delete<string>(`impacts`, { data: { ids } })
  }

  cancelRemove(params: ICancelRemovalDto) {
    return this.get<IMessageResponseDto>('impacts/cancel-deletion', { params })
  }

  async getImpacts(params?: {}) {
    return await this.get<IImpactsRespDto>(`impacts`, { params })
  }

  async getFilteredImpacts(params?: {}) {
    if (this.cancel) {
      this.cancel()
    }

    return await this.get<IImpactsRespDto>(`impacts`, {
      params,
      cancelToken: new this.CancelToken((c) => {
        this.cancel = c
      }),
    })
  }

  checkCodeExist(code: string, id?: string, accountId?: string) {
    return this.get<IMessageResponseDto>(`impacts/code/${code}`, {
      params: { accountId, id },
    })
  }

  getInitialCode(accountId?: string) {
    const res = this.get<string>(`impacts/code/initial`, { params: { accountId } })
    return res
  }
}

const ImpactService = new ImpactDataService()
export default ImpactService
